import React, { ComponentProps, memo } from 'react'

import { useTranslation } from '../services'

import { DefaultDialog } from './DefaultDialog'

export const DefaultDangerActionConfirmationDialog = memo(
  ({
    title,
    text,
    confirmButtonLabel,
    cancelButtonLabel,
    ...rest
  }: Omit<ComponentProps<typeof DefaultDialog>, 'buttonVariant'>) => {
    const { t } = useTranslation()

    return (
      <DefaultDialog
        {...{
          title: title ?? t('defaultDialog.title'),
          text: text ?? t('defaultDangerActionConfirmationDialog.text'),
          confirmButtonLabel:
            confirmButtonLabel ??
            t('defaultDangerActionConfirmationDialog.confirmButtonLabel'),
          cancelButtonLabel: cancelButtonLabel ?? t('cancelButtonLabel'),
          buttonVariant: 'danger',
          ...rest,
        }}
      />
    )
  },
)
